import { useState } from "react";
import API from "../services/api";
import { useNavigate } from "react-router-dom";

export default function ParentLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const res = await API.post("/portal-auth/login", {
        username,
        password
      });

      localStorage.setItem(
        "parentToken",
        res.data.token
      );

      localStorage.setItem(
        "studentId",
        res.data.student_id
      );

      alert("Login successful");

      navigate("/parent-dashboard");

    } catch (err) {
      alert("Login failed");
    }
  };

  return (
    <div className="p-6 flex justify-center items-center min-h-screen bg-gray-100">
      <div className="bg-white shadow p-6 rounded w-full max-w-md">

        <h1 className="text-2xl font-bold mb-6 text-center">
          Parent Portal Login
        </h1>

        <input
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="border p-2 mb-3 w-full"
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="border p-2 mb-3 w-full"
        />

        <button
          onClick={handleLogin}
          className="bg-blue-600 text-white px-4 py-2 rounded w-full"
        >
          Login
        </button>

      </div>
    </div>
  );
}